<template>
  <div class="myAdvantage">
    <!-- 头部 -->
    <zmlmenupage
      cn-name="企业优势"
      en-name="Enterprise Advantages"
    ></zmlmenupage>

    <zmlpagebanner
      banner-img="static/img/proBanner.png"
      banner-text="货运江湖，一键启航！"
      cn-name="产品中心"
      en-name="Product Center"
    >
    </zmlpagebanner>

    <!-- 平台优势 -->
    <div class="myAdvantage-pt">
      <div class="info myAdvantage-pt-info">
        <div class="myAdvantage-title">平台优势</div>
        <div class="advantage-item">
          <div class="advantage-item-title">
            让行业痛点成为<span>过去式</span>
          </div>
          <div class="advantage-item-box flexCenter">
            <div class="advantage-item-box-li">
              <div class="advantage-item-box-li-title flexCenter">交易安全</div>
              <div class="advantage-item-box-li-text">
                <ul>
                  <li>无船承运人资质+网络货运资质</li>
                  <li>网络信息安全等保三级资质</li>
                  <li>网络增值服务ICP和EDI证书</li>
                </ul>
              </div>
            </div>
            <div class="advantage-item-box-li">
              <div class="advantage-item-box-li-title flexCenter">高效便捷</div>
              <div class="advantage-item-box-li-text">
                <ul>
                  <li>一键线上交易 智能匹配车船货</li>
                  <li>运费在线支付 零手续费</li>
                  <li>无纸化操作 数据保留云端 随时查看</li>
                </ul>
              </div>
            </div>
            <div class="advantage-item-box-li">
              <div class="advantage-item-box-li-title flexCenter">物流管理</div>
              <div class="advantage-item-box-li-text">
                <ul>
                  <li>货流实时监控 轨迹数据真实</li>
                  <li>跟单审核机制 运单风险自动预警</li>
                  <li>线上资源优化配置 线下高效运输</li>
                </ul>
              </div>
            </div>
            <div class="advantage-item-box-li">
              <div class="advantage-item-box-li-title flexCenter">税务闭环</div>
              <div class="advantage-item-box-li-text">
                <ul>
                  <li>平台开放接口给税务局</li>
                  <li>五流合一 真实数据源</li>
                  <li>保障税务链条完整合法</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- 手机端 -->
        <div class="phone-advantage-swiper-item">
          <div class="advantage-item-title">
            让行业痛点成为<span>过去式</span>
          </div>
          <swiper ref="mySwiper" :options="swiperOptions1">
            <swiper-slide>
              <div class="advantage-item-box-li">
                <div class="advantage-item-box-li-title flexCenter">
                  交易安全
                </div>
                <div class="advantage-item-box-li-text">
                  <ul>
                    <li>无船承运人资质+网络货运资质</li>
                    <li>网络信息安全等保三级资质</li>
                    <li>网络增值服务ICP和EDI证书</li>
                  </ul>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="advantage-item-box-li">
                <div class="advantage-item-box-li-title flexCenter">
                  高效便捷
                </div>
                <div class="advantage-item-box-li-text">
                  <ul>
                    <li>一键线上交易 智能匹配车船货</li>
                    <li>运费在线支付 零手续费</li>
                    <li>无纸化操作 数据保留云端 随时查看</li>
                  </ul>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="advantage-item-box-li">
                <div class="advantage-item-box-li-title flexCenter">
                  物流管理
                </div>
                <div class="advantage-item-box-li-text">
                  <ul>
                    <li>货流实时监控 轨迹数据真实</li>
                    <li>跟单审核机制 运单风险自动预警</li>
                    <li>线上资源优化配置 线下高效运输</li>
                  </ul>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="advantage-item-box-li">
                <div class="advantage-item-box-li-title flexCenter">
                  税务闭环
                </div>
                <div class="advantage-item-box-li-text">
                  <ul>
                    <li>平台开放接口给税务局</li>
                    <li>五流合一 真实数据源</li>
                    <li>保障税务链条完整合法</li>
                  </ul>
                </div>
              </div>
            </swiper-slide>
            <div
              class="swiper-pagination phone-service-page"
              slot="pagination"
            ></div>
          </swiper>
        </div>
      </div>
    </div>
    <!-- 技术优势 -->
    <div class="myAdvantage-js">
      <div class="info myAdvantage-js-info">
        <div class="myAdvantage-title">技术优势</div>
        <div class="advantage-item">
          <div class="advantage-item-title">
            让科技为您<span>保驾护航</span>
          </div>
          <div class="advantage-item-box flexCenter">
            <div class="advantage-item-box-li">
              <div class="advantage-item-box-li-title flexCenter">
                高效智能匹配算法
              </div>
              <div class="advantage-item-box-li-text">
                <ul>
                  <li>就近派单 减少空载 高效装卸货</li>
                  <li>行业大数据精准分析 根据运费趋势</li>
                  <li>生成平台高效的全域运力调动算法</li>
                </ul>
              </div>
            </div>
            <div class="advantage-item-box-li">
              <div class="advantage-item-box-li-title flexCenter">
                完整运输服务体系
              </div>
              <div class="advantage-item-box-li-text">
                <ul>
                  <li>陆运与水运结合 提供水陆多式联运服务</li>
                  <li>提高运输管理水平 实现“门到门”运输</li>
                  <li>合理规划路线 降低运输成本 增加经济效益</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- 手机端 -->
        <div class="phone-advantage-swiper-item">
          <div class="advantage-item-title">
            让科技为您<span>保驾护航</span>
          </div>
          <swiper ref="mySwiper" :options="swiperOptions1">
            <swiper-slide>
              <div class="advantage-item-box-li">
                <div class="advantage-item-box-li-title flexCenter">
                  高效智能匹配算法
                </div>
                <div class="advantage-item-box-li-text">
                  <ul>
                    <li>就近派单 减少空载 高效装卸货</li>
                    <li>行业大数据精准分析 根据运费趋势</li>
                    <li>生成平台高效的全域运力调动算法</li>
                  </ul>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="advantage-item-box-li">
                <div class="advantage-item-box-li-title flexCenter">
                  完整运输服务体系
                </div>
                <div class="advantage-item-box-li-text">
                  <ul>
                    <li>陆运与水运结合 提供水陆多式联运服务</li>
                    <li>提高运输管理水平 实现“门到门”运输</li>
                    <li>合理规划路线 降低运输成本 增加经济效益</li>
                  </ul>
                </div>
              </div>
            </swiper-slide>
            <div
              class="swiper-pagination phone-service-page"
              slot="pagination"
            ></div>
          </swiper>
        </div>
      </div>
    </div>
    <!-- 技术证书 -->
    <div class="myAdvantage-zs">
      <div class="info myAdvantage-zs-info flexBetween">
        <div class="myAdvantage-zs-left">
          <div class="myAdvantage-title">技术证书</div>
          <div class="myAdvantage-zs-left-text1">
            <p>多达<span>74项</span>知识产权及 行业专利备案</p>
            <p>（已受理及待受理）</p>
          </div>
          <div class="myAdvantage-zs-left-text2">
            <ul>
              <li>AI大数据</li>
              <li>5G智慧匹配算法</li>
              <li>可视化物流管理系统</li>
              <li>AIS船舶轨迹定位</li>
              <li>阿里云服务器</li>
              <li>GPS车辆轨迹定位</li>
            </ul>
          </div>
        </div>
        <!-- <div class="myAdvantage-zs-right">
					<div class="myAdvantage-zs-item flexCenter">
					</div>
					<div class="myAdvantage-zs-item flexCenter">
						<p>航运交易</p>
						<p>互联网平台</p>
					</div>
					<div class="myAdvantage-zs-item flexCenter zsHover">
						<div class="myAdvantage-zs-item-text flexCenter">
							<p>三级等保证书</p>
							<span>银资金与信息安全官方高等级认证<span>（除银行业外）</span></span>
						</div>
						<img class="zsImgs" src="../../static/img/zs1.png" alt="">
						<img src="../../static/img/jiantou.png" width="54" class="jt"  alt="">
					</div>
					<div class="myAdvantage-zs-item flexCenter zs-detail">
						<p>三级等保证书，由公安机关依据国家信息安全保护条例及相关制度规定，按照管理规范和技术标准，对各机构的信息系统安全等级保护状况进行认可及评定。</p>
					</div>
					
				 移动端可见 
					<div class="myAdvantage-zs-item phone-zs-img flexCenter">
					</div>
					
				</div> -->
        <div class="myAdvantage-zs-right-img">
          <img src="../../static/img/license.png" alt="" />
        </div>
      </div>
    </div>
    <!-- 三级等保 -->
    <div class="myAdvantage-zs2">
      <div class="info myAdvantage-zs-info flexBetween">
        <div class="myAdvantage-zs-left">
          <div class="myAdvantage-title">三级等保证书</div>
          <div class="myAdvantage-zs-left-text1">
            <p><span>三级等保证书</span>是网络信息安全高等级认证</p>
          </div>
          <div>
            <p>
              三级等保证书，由公安机关依据国家信息安全保护条例及相关制度规定，按照管理规范和技术标准，对各机构的信息系统安全等级保护状况进行认可及评定。
            </p>
          </div>
          <div>
            <p>
              三级等保证书属于“监管级别”，由国家信息安全监管部门进行监督、检查，认证，测评内容分别涵盖5个等级保护安全技术+5个安全管理要求，包含信息保护、安全审计、通信保密等近300项要求，共涉及测评分类73类。
            </p>
          </div>
        </div>
        <div class="myAdvantage-zs-right-img">
          <img src="../../static/img/WechatIMG159.jpeg" alt="" />
        </div>
      </div>
    </div>
    <!-- 证书展示 -->
    <!-- <div class="myAdvantage-zsShow">
			<div class="info myAdvantage-zsShow-info">
				<div class="myAdvantage-title">证书展示</div>
				<div class="myAdvantage-zsShow-swiper">
					<swiper ref="mySwiper" :options="swiperOptions">
						<swiper-slide>
							<div class="myAdvantage-zsShow-swiper-img">
								<img src="../../static/img/zs.png" alt="">
							</div>
							<p>广东省交通运输协会理事会员</p>
						</swiper-slide>
						<swiper-slide>
							<div class="myAdvantage-zsShow-swiper-img">
								<img src="../../static/img/zs.png" alt="">
							</div>
							<p>广东省交通运输协会理事会员</p>
						</swiper-slide>
						<swiper-slide>
							<div class="myAdvantage-zsShow-swiper-img">
								<img src="../../static/img/zs.png" alt="">
							</div>
							<p>广东省交通运输协会理事会员</p>
						</swiper-slide>
						<swiper-slide>
							<div class="myAdvantage-zsShow-swiper-img">
								<img src="../../static/img/zs.png" alt="">
							</div>
							<p>广东省交通运输协会理事会员</p>
						</swiper-slide>
						<swiper-slide>
							<div class="myAdvantage-zsShow-swiper-img">
								<img src="../../static/img/zs.png" alt="">
							</div>
							<p>广东省交通运输协会理事会员</p>
						</swiper-slide>
					</swiper>
				</div> -->

    <!-- 移动端可见 -->
    <!-- <div class="phone-myAdcantage-zslist">
					<div class="phone-myAdcantage-zsItem">
						<div class="phone-myAdcantage-zsImg"><img src="../../static/img/zs.png" alt=""></div>
						<p>广东省交通运输协会理事会员</p>
					</div>
					<div class="phone-myAdcantage-zsItem">
						<div class="phone-myAdcantage-zsImg"><img src="../../static/img/zs.png" alt=""></div>
						<p>广东省交通运输协会理事会员</p>
					</div>
					<div class="phone-myAdcantage-zsItem">
						<div class="phone-myAdcantage-zsImg"><img src="../../static/img/zs.png" alt=""></div>
						<p>广东省交通运输协会理事会员</p>
					</div>
					<div class="phone-myAdcantage-zsItem">
						<div class="phone-myAdcantage-zsImg"><img src="../../static/img/zs.png" alt=""></div>
						<p>广东省交通运输协会理事会员</p>
					</div>
				</div>
				<div class="findMore">查看更多</div> -->

    <!--</div> 
		</div>-->
    <gototop></gototop>
  </div>
</template>
<script>
export default {
  name: "advantage",
  data() {
    return {
      swiperOptions: {
        slidesPerView: 3,
        spaceBetween: 124,
      },
      swiperOptions1: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      is_zs: true,
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
};
</script>
<style scoped="scoped">
/* 平台优势 */
.myAdvantage-pt {
  width: 100%;
  height: auto;
  background-color: #f4f4f6;
  padding: 100px 0;
  overflow: hidden;
}
/* 技术优势 */
.myAdvantage-js {
  width: 100%;
  height: auto;
  background: url(../../static/img/bg.jpg) no-repeat center;
  background-size: cover;
  background-color: #000;
  padding: 100px 0;
  overflow: hidden;
  background-attachment: fixed;
}
/* 技术证书 */
.myAdvantage-zs {
  width: 100%;
  height: auto;
  background-color: #f4f4f6;
  padding: 100px 0;
}
/* 三级证书 */
.myAdvantage-zs2 {
  width: 100%;
  height: auto;
  background-color: #f4f4f6;
  padding-bottom: 100px;
}
/* 证书展示 */
.myAdvantage-zsShow {
  width: 100%;
  height: auto;
  background-color: #fff;
  padding: 100px 0 200px;
  overflow: hidden;
}

.myAdvantage-title {
  width: 100%;
  height: auto;
  font-size: 28px;
  font-weight: bold;
}

.myAdvantage-js-info .advantage-item-title {
  color: #fff;
}
.myAdvantage-js-info .myAdvantage-title {
  color: #fff;
}
.myAdvantage-zs-left,
.myAdvantage-zs-right {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
}
.myAdvantage-zs-right-img {
  display: inline-block;
  width: 50%;
  height: 100%;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
}
.myAdvantage-zs-right-img img {
  width: 100%;
  height: 100%;
}
.myAdvantage-zs-left-text1,
.myAdvantage-zs-left-text2 {
  padding: 0px 120px 0px 80px;
}
.myAdvantage-zs-left-text1 p:nth-of-type(1) {
  font-size: 54px;
}
.myAdvantage-zs-left-text1 p:nth-of-type(1) span {
  color: #127bfd;
}
.myAdvantage-zs-left-text1 p:nth-of-type(2) {
  font-size: 20px;
  color: #999;
}
.myAdvantage-zs-left-text2 ul li {
  list-style: disc;
  margin-left: 25px;
  line-height: 34px;
}

.myAdvantage-zs-item {
  width: 297px;
  height: 346px;
  background-color: #fff;
  border: 1px solid rgba(222, 222, 222, 1);
  margin-right: -1px;
  margin-bottom: -1px;
  flex-flow: column;
  position: relative;
}
.myAdvantage-zs-item p {
  line-height: 38px;
  font-size: 24px;
}
.myAdvantage-zs-item .jt {
  position: absolute;
  bottom: 30px;
  right: 30px;
  cursor: pointer;
}
.myAdvantage-zs-item-text {
  flex-flow: column;
  padding: 0 50px;
  text-align: center;
  font-size: 14px;
  opacity: 1;
  transition: 0.5s;
}

.myAdvantage-zs-item-text span {
  margin-top: 15px;
  line-height: 24px;
}
.myAdvantage-zs-item-text span span {
  color: #ff821a;
}

.zs-detail {
  background-color: #127bfd;
  color: #fff;
  font-size: 14px;
  line-height: 22px;
  padding: 30px;
  /* display: none; */
  opacity: 0;
  transition: 0.3s;
}
.zs-detail p {
  color: #fff;
  font-size: 14px;
  line-height: 22px;
  margin: 10px 0;
}

.myAdvantage-zsShow-swiper {
  margin-top: 65px;
  /* padding: 0px 78px; */
}
.myAdvantage-zsShow-swiper-img {
  width: 384px;
  height: 272px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.1);
  padding: 7px 10px;
}
.swiper-slide {
  width: auto !important;
  transition: 0.3s;
}
.swiper-slide p {
  font-size: 16px;
  color: #666;
  margin-top: 24px;
  text-align: center;
}
.swiper-container {
  overflow: inherit;
}
.swiper-slide:hover {
  transform: translateY(-30px);
}

.zsImgs {
  opacity: 0;
  transition: 0.5s;
  position: absolute;
}
.zsHover:hover .myAdvantage-zs-item-text {
  opacity: 0;
}
.zsHover:hover img:nth-of-type(2) {
  display: none;
}
.zsHover:hover .zsImgs {
  opacity: 1;
}
.zsHover:hover + .zs-detail {
  opacity: 1;
}

.phone-advantage-swiper-item,
.zsBox,
.phone-myAdcantage-zslist,
.phone-zs-img {
  display: none;
}

@media only screen and (max-width: 750px) {
  .phone-advantage-swiper-item {
    display: block;
  }
  .myAdvantage-pt {
    padding-top: 0;
  }
  .myAdvantage-title {
    padding: 23px 0;
    font-size: 14px;
    font-weight: bold;
  }
  .advantage-item {
    display: none;
  }
  .advantage-item-title {
    padding: 20px;
    font-size: 40px;
    /* font-weight: 700; */
  }
  .advantage-item-box-li {
    width: 220px;
    height: 320px;
  }
  .swiper-container {
    overflow: inherit;
  }
  .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .advantage-item-box-li-title {
    height: 46px;
    font-size: 18px;
    /* font-weight: bold; */
  }
  .advantage-item-box-li-text {
    padding: 20px;
  }
  .advantage-item-box-li-text ul li {
    font-size: 14px;
    margin-left: 12px;
    line-height: 20px;
    margin-bottom: 15px;
  }
  .swiper-pagination {
    bottom: -50px !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .phone-service-page >>> .swiper-pagination-bullet-active {
    width: 12px;
    height: 12px;
    opacity: 1;
    background: url(../../static/img/active-point.png) no-repeat center;
    background-size: cover;
  }
  .swiper-slide {
    width: 100% !important;
  }

  .myAdvantage-js {
    padding-top: 0;
  }
  .myAdvantage-zs {
    padding: 0 0 50px 0;
  }
  .myAdvantage-zs-info {
    display: block;
  }
  .myAdvantage-zs-left-text1,
  .myAdvantage-zs-left-text2 {
    padding: 23px 0;
  }
  .myAdvantage-zs-left-text1 p:nth-of-type(1) {
    font-size: 27px;
  }
  .myAdvantage-zs-left-text1 p:nth-of-type(2) {
    font-size: 14px;
    margin-top: 10px;
  }
  .myAdvantage-zs-left-text2 ul li {
    font-size: 14px;
    margin-left: 18px;
  }
  .myAdvantage-zs-item {
    width: 50%;
    height: auto;
    min-height: 196px;
    padding: 20px 15px;
  }
  .myAdvantage-zs-item img {
    width: 100%;
  }
  .myAdvantage-zs-item p {
    font-size: 15px;
    line-height: 27px;
  }
  .zsBox {
    width: 100%;
    display: block;
    padding: 27px;
    font-size: 12px;
    color: #fff;
    background-color: #127bfd;
  }
  .zsBox p {
    margin: 10px 0;
    line-height: 20px;
  }
  .myAdvantage-zsShow {
    padding-top: 0;
  }
  .myAdvantage-zsShow-swiper {
    margin-top: 0;
    padding: 0;
    display: none;
  }
  .phone-myAdcantage-zslist {
    display: block;
    padding: 20px;
  }
  .phone-myAdcantage-zsImg {
    padding: 10px;
    box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.1);
  }
  .phone-myAdcantage-zsItem {
    margin-bottom: 20px;
  }
  .phone-myAdcantage-zsItem img {
    width: 100%;
  }
  .phone-myAdcantage-zsItem p {
    font-size: 13px;
    color: #666;
    margin-top: 10px;
    padding-left: 10px;
  }

  .myAdvantage-zs-item-text {
    padding: 0;
  }
  .jt {
    display: none;
  }
  .phone-zs-img {
    display: block;
    padding: 20px;
  }

  .zs-detail {
    display: none;
  }
  .myAdvantage-zs-left-text1 {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/advantage.vue